import(/* webpackMode: "eager", webpackExports: ["PrismicToolbar"] */ "/var/www/static-website/node_modules/@prismicio/react/dist/PrismicToolbar.js");
;
import(/* webpackMode: "eager" */ "/var/www/static-website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/static-website/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/static-website/src/components/atoms/Card/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/atoms/Cta/Cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/atoms/Typography/H1/H1.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/atoms/Typography/H2/H2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/atoms/Typography/H3/H3.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/atoms/Typography/H4/H4.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/atoms/Typography/H5/H5.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/atoms/Typography/H6/H6.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/static-website/src/components/atoms/Typography/P/index.ts");
;
import(/* webpackMode: "eager" */ "/var/www/static-website/src/components/atoms/Typography/Title/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/layout/Section/Section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/molecules/ButtonsFactory/ButtonsFactory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/molecules/ContentText/ContentText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/molecules/IconPointerList/components/DecoContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/molecules/IconPointerList/components/InstallmentsModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/molecules/ShowMore/ShowMore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/molecules/SwiperElement/SwiperElement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/organisms/RegistrationForm/RegistrationForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/sections/AccordionSection/AccordionSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/sections/ContactSection/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/sections/ImagesItemsSection/ImagesItemsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/sections/InlineTilesSection/InlineTilesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/sections/VideoSection/VideoSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/BasicContent/BasicContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/BusinessContactFormTemplate/BusinessContactFormTemplate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/CategoriesCardTemplate/CategoriesCardTemplate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/IconPointerListContent/components/PromoCode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/IntegrationContentTemplate/_components/IntegrationSteps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/IntegrationContentTemplate/_components/LinksList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/IntegrationSideContentTemplate/_components/SelectMenu/SelectMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/OrderedCardTemplate/OrderedCardTemplate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/ProductTileTemplate/ProductTileTemplate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/QRCodeTemplate/QRCodeTemplate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/SearchBarContent/SearchBarContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/SubCategoriesCardTemplate/SubCategoriesCardTemplate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/templates/TextContent/TextContent.tsx");
